import React from "react";
import "./Servives.css";
import HearEmoji from "../../img/heartemoji.png";
import Glasses from "../../img/glasses.png";
import Humble from "../../img/humble.png";
import Card from "../Card/Card";
import Resume from "./resume.pdf";
import { motion } from "framer-motion";

const skills = [
  "HTML",
  "CSS",
  "Sass",
  "JavaScript",
  "React",
  "Node.js",
  "Express",
  "MySQL",
  "Yarn",
  "Postman",
  "Figma",
  "Adobe",
  "Canva",
];

function Services() {
  const transition = { duration: 1.2, type: "spring" };

  return (
    <section className="services section" id="Services">
      <div className="services-inner container">
        <div className="awesome">
          <div className="section-heading">
            <span>Mes</span>
            <span className="accent">services</span>
          </div>
          <p className="section-copy">
            Développeuse fullstack recherchant un contrat en alternance. Je
            conçois des interfaces modernes et des APIs solides, du design à la
            mise en production.
          </p>
          <a href={Resume} download>
            <button type="button" className="button s-button">
              Télécharger CV
            </button>
          </a>

          <div className="skills-grid" aria-label="Compétences">
            {skills.map((skill) => (
              <span className="skill-badge" key={skill}>
                {skill}
              </span>
            ))}
          </div>
          <div className="blur s-blur1" style={{ background: "#ABF1FF94" }} />
        </div>

        <div className="cards">
          <motion.div
            className="card-wrap card-wrap-1"
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={transition}
          >
            <Card
              emoji={HearEmoji}
              heading="Design"
              detail="Figma, Adobe, Canva"
              tone="orange"
            />
          </motion.div>
          <motion.div
            className="card-wrap card-wrap-2"
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ ...transition, delay: 0.08 }}
          >
            <Card
              emoji={Glasses}
              heading="Front-end"
              detail="HTML, CSS, Sass, JavaScript, React"
              tone="blue"
            />
          </motion.div>
          <motion.div
            className="card-wrap card-wrap-3"
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ ...transition, delay: 0.16 }}
          >
            <Card
              emoji={Humble}
              heading="Back-end"
              detail="Express, MySQL, Node.js, Yarn, Postman"
              tone="purple"
            />
          </motion.div>
          <div className="blur s-blur2" style={{ background: "var(--purple)" }} />
        </div>
      </div>
    </section>
  );
}

export default Services;
